import 'core-js/fn/symbol';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

import { loadCartDataFromLocalstorage } from 'model/cart';
import { loadTokenFromCookie } from 'model/auth';

import { detectLocalStorageSupport } from 'util/storage';
import { addVisibleListenerForToken } from 'util/event';

// A modern alternative to CSS resets
import 'normalize.css';
// Global css setting
import './global.css';

import configureStore from './store';
import Routes from './routes';

const store = configureStore({});
const history = syncHistoryWithStore(browserHistory, store);

detectLocalStorageSupport();
addVisibleListenerForToken(store);

store.dispatch(loadCartDataFromLocalstorage());
store.dispatch(loadTokenFromCookie());

ReactDOM.render(<Routes store={store} history={history} />, document.getElementById('content'));
